export default __webpack_public_path__ + "static/media/rightArrowGreen.1c9bd1df.svg";